module.exports = __webpack_public_path__ + "media/images/version_merge/raffle_promotion-error-d08c78bca7ff41f5feb9a75fc30dfe5e.jpg";